import Auth0Identity from './identity';

import { fireEvent } from '../utils/events';

declare global {
  interface Window {
    Sales: any;
  }
}

/**
 * Terminates a session via Auth0 logout method. This will also clear out `userIdentity`.
 * @param returnTo url passed to the Auth0 logout method to visit after successful logout
 *
 * @returns
 * A __Promise__ which resolves to null (if successful). Clears out `userIdentity`.
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for more info:
 * https://auth0.github.io/auth0-spa-js/classes/auth0client.html#logout
 * ```
 * </details>
 *
 */
export default async function logout(returnTo: string) {
  const isLoggedIn = await Auth0Identity.isLoggedIn();
  if (isLoggedIn) {
    try {
      dispatchLogoutEvent();
      Auth0Identity.clearSession();
      Auth0Identity.auth0.logout({
        returnTo
      });
    } catch (err) {
      throw err;
    }
  } else if (Auth0Identity.userIdentity.accessToken) {
    Auth0Identity.heartbeat().then(() => {
      try {
        Auth0Identity.auth0.logout({
          returnTo
        });
      } catch (err) {
        throw err;
      }
    });
  } else {
    throw 'No access token found, user is already logged out';
  }
}

export const dispatchLogoutEvent = () => fireEvent('ArcSDK.logout');
